import { useEffect, useRef, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { uploadBlob } from "../lib/media";
import AuthMedia from "./AuthMedia";
import { Button } from "./ui/button";
import { Music4, Upload, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";

const BackgroundMusicCard = ({ embedded = false }) => {
  const [music, setMusic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  useEffect(() => {
    api.get("/profile").then((res) => setMusic(res.data.background_music)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const data = await uploadBlob(file, file.name);
      await api.put("/profile/music", { media: data });
      setMusic(data);
      toast.success("Musica impostata");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore");
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const remove = async () => {
    setBusy(true);
    try {
      await api.put("/profile/music", { media: null });
      setMusic(null);
      toast.success("Musica rimossa");
    } finally {
      setBusy(false);
    }
  };

  if (loading) return null;

  return (
    <div className={`flex flex-col sm:flex-row sm:items-center gap-4 ${embedded ? "" : "bg-white rounded-2xl border border-border p-6 mb-8"}`} data-testid="music-card">
      <div className="w-12 h-12 rounded-xl bg-[#F0EAF4] flex items-center justify-center shrink-0">
        <Music4 className="w-6 h-6 text-[#8A6D9C]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-serif text-lg">Musica della Capsula del Tempo</p>
        <p className="text-sm text-muted-foreground">
          {music ? `Brano scelto: ${music.original_filename}` : "Scegli un brano che accompagni i tuoi cari mentre sfogliano i ricordi."}
        </p>
        {music && <div className="mt-3 max-w-sm"><AuthMedia item={music} /></div>}
      </div>
      <div className="flex items-center gap-2">
        <Button onClick={() => fileRef.current?.click()} disabled={busy} variant="outline" className="rounded-full border-border" data-testid="music-upload-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Upload className="w-4 h-4 mr-2" />}
          {music ? "Cambia" : "Scegli brano"}
        </Button>
        {music && (
          <Button onClick={remove} disabled={busy} variant="ghost" className="rounded-full text-destructive hover:bg-destructive/10" data-testid="music-remove-btn">
            <Trash2 className="w-4 h-4" />
          </Button>
        )}
      </div>
      <input ref={fileRef} type="file" accept="audio/*" onChange={upload} className="hidden" data-testid="music-file-input" />
    </div>
  );
};

export default BackgroundMusicCard;
